import { Formik } from 'formik'
import { Form, Input } from 'antd'
import Button from 'components/button/Button'
import { phoneInputValidation, pinInputValidation, phonePasteValidation } from 'helpers/validation'
import { IconLock, IconSingleUser } from 'components/icons'

export interface SignInFormValues {
  phone_number: string
  pin: string
}

interface IProps {
  loading: boolean
  errorMessage: string
  onSubmit: (values: SignInFormValues) => void
}

function SigninForm(props: IProps) {
  const { loading, errorMessage, onSubmit } = props
  return (
    <Formik
      initialValues={{
        phone_number: '',
        pin: ''
      }}
      validateOnMount={false}
      onSubmit={(values) => onSubmit(values)}
    >
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <Form
          data-testid="input_login"
          onFinish={handleSubmit}
          layout="vertical"
          className="auth-card__form"
        >
          <div className="mb-6">
            <Form.Item name="phone-number" className="auth-card__form__item" label="Nomor Telepon">
              <Input
                data-testid="input_phone_number"
                value={values.phone_number}
                onKeyDown={(event) => phoneInputValidation(event, values.phone_number, 13)}
                onPaste={(e) => phonePasteValidation(e, values.phone_number, 13)}
                onChange={handleChange('phone_number')}
                onBlur={handleBlur('phone_number')}
                className="auth-card__form__input"
                placeholder="08xxxxxxxxxx"
                prefix={<IconSingleUser color="#3C5337" className="mr-2" />}
              />
            </Form.Item>
          </div>

          <div className="mb-6">
            <Form.Item name="pin" className="auth-card__form__item" label="PIN">
              <Input.Password
                autoComplete="false"
                data-testid="input_pin_login"
                value={values.pin}
                onKeyDown={(event) => pinInputValidation(event, values.pin, 6)}
                onChange={handleChange('pin')}
                onBlur={handleBlur('pin')}
                className="auth-card__form__input"
                placeholder="******"
                prefix={<IconLock color="#3C5337" className="mr-2" />}
              />
            </Form.Item>
            {errorMessage && (
              <p data-testid="error_message" className="mt-1 text-sm italic text-danger">
                {errorMessage}
              </p>
            )}
          </div>
          <Button
            type="submit"
            loading={loading}
            disabled={values.phone_number.length < 10 || values.pin.length < 6 || loading}
            block={true}
            onClick={() => handleSubmit}
            data-testid="btn_submit"
            className="auth-card__submit pt-3 pb-3 font-bold text-sm"
            label="Masuk"
            variant="solid-primary"
          />
        </Form>
      )}
    </Formik>
  )
}

export default SigninForm
